import axios from 'axios';
import { mutate } from 'swr';
import { Notistack } from '../../../../shared/components/Notistack/Notistack';
import { IQueueConfiguration } from './types';

const path = '/configuration-service/queue-configurations';

export const requestUpdateQueueConfiguration = (data: IQueueConfiguration) => {
  return mutate(path, async() => {
    try {
      await axios.patch(`${path}/${data.id}`, data);
      Notistack.successMessage('Configuration - Updated Successfully');
    } catch (err) {
      const error = err as { response: { data: { message: string } } };
      Notistack.generalError(error?.response?.data?.message);
    }
  });
};

export const requestCreateQueueConfiguration = (data: IQueueConfiguration) => {
  return mutate(path, async() => {
    try {
      await axios.put(path, data);
      Notistack.successMessage('Configuration - Created Successfully');
    } catch (err) {
      const error = err as { response: { data: { message: string } } };
      Notistack.generalError(error?.response?.data?.message);
    }
  });
};
